// Rotating positioning lines. Pinned to the canonical
// "Level up by producing real outcomes." (index 0) plus a small set of
// on-message alternates. We rotate deterministically per visitor session
// (sessionStorage) so the line stays stable while a user navigates between
// pages — but each new tab/visit picks up a fresh angle. Keep this list
// short and tightly on-strategy; this is positioning, not marketing fluff.
export const TAGLINES = [
  "Level up by producing real outcomes.",
  "Stop reading about AI. Start shipping with it.",
  "Quests, points, real work. The game for mastering AI.",
  "Practice AI like a sport. Get points for finishing.",
  "Less scrolling, more shipping.",
  "Turn AI curiosity into a portfolio.",
  "Daily reps that make you dangerous with AI.",
] as const;

const SESSION_KEY = "hl:tagline_idx:v1";

/** Returns the tagline for this session, picking + caching one on first call. */
export function getSessionTagline(): string {
  if (typeof window === "undefined") return TAGLINES[0];
  try {
    const cached = window.sessionStorage.getItem(SESSION_KEY);
    const cachedIdx = cached === null ? NaN : Number(cached);
    if (Number.isInteger(cachedIdx) && cachedIdx >= 0 && cachedIdx < TAGLINES.length) {
      return TAGLINES[cachedIdx];
    }
    const idx = Math.floor(Math.random() * TAGLINES.length);
    window.sessionStorage.setItem(SESSION_KEY, String(idx));
    return TAGLINES[idx];
  } catch {
    return TAGLINES[0];
  }
}

/** Same logic as getSessionTagline but returns the index. Used by the
 *  rotating-tagline hook so it can advance from the current position
 *  instead of restarting at 0 on every route change. */
export function getSessionTaglineIndex(): number {
  if (typeof window === "undefined") return 0;
  try {
    const cached = window.sessionStorage.getItem(SESSION_KEY);
    const cachedIdx = cached === null ? NaN : Number(cached);
    if (
      Number.isInteger(cachedIdx) &&
      cachedIdx >= 0 &&
      cachedIdx < TAGLINES.length
    ) {
      return cachedIdx;
    }
    const idx = Math.floor(Math.random() * TAGLINES.length);
    window.sessionStorage.setItem(SESSION_KEY, String(idx));
    return idx;
  } catch {
    return 0;
  }
}